import { requestGet, requestPost } from 'utils/request';
import { handleErrors, logError } from '@tcc/scarecrow';
import scopes from 'constants/scopes';

const BASE_URL = '/api';

function handleLoginError(response) {
  if (response.ok) {
    return response.json();
  }

  const message = `Endpoint Error: ${response.status} ${response.statusText}`;
  const requestId = response.headers.get('x-http-request-id');
  const extraData = { serviceError: { ...response, requestId } };
  logError(message, extraData, true);

  return Promise.reject({
    status: response.status,
    statusText: response.statusText
  });
}

export function loginRequest(username, password) {
  const user = encodeURIComponent(username);
  const pass = encodeURIComponent(password);
  const scope = encodeURIComponent(scopes.join(' '));
  return requestPost(`${BASE_URL}/oauth/cookie`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: `grant_type=password&username=${user}&password=${pass}&scope=${scope}`
  }).
    then(handleLoginError);
}

export function loggedInCheckRequest() {
  return requestPost(`${BASE_URL}/oauth/cookie`, {
  }).then((response) => response.json());
}

export function getFieldsRequest(userId) {
  return requestGet(`${BASE_URL}/fields`, {
    headers: {
      'x-user-id': userId
    }
  }).
    then(handleErrors);
}

export function clearCookiesRequest() {
  return requestGet(`${BASE_URL}/oauth/clearcookie`).
    then(handleErrors);
}
